export class InvalidWorkbookError extends Error {
  constructor(message = "Not a readable .xlsx workbook") {
    super(message);
    this.name = "InvalidWorkbookError";
  }
}
